{
  "modal_message": "구찌 앱을 사용하고 계신가요?",
  "modal_yes": "예",
  "modal_no": "아니요"
}
